import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function useSalesSummaryParams() {
    const history = useHistory();
    const location = useLocation();

    const dateRange = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const startDate = params.get('start');
        const endDate = params.get('end');

        if (startDate && endDate) {
            return { startDate, endDate };
        }

        return { startDate: null, endDate: null };
    }, [location.search]);

    const setDateRange = (startDate, endDate) => {
        const params = new URLSearchParams(location.search);

        if (startDate && endDate) {
            params.set('start', startDate);
            params.set('end', endDate);
        } else {
            params.delete('start');
            params.delete('end');
        }

        const search = params.toString();

        history.replace({
            pathname: location.pathname,
            search: search ? `?${search}` : '',
        });
    };

    return {
        dateRange,
        setDateRange,
    };
}
